exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tab-header .title {\n  margin-bottom: 0;\n  font-size: 16px;\n  font-weight: bold;\n}\n.tab-header .description {\n  font-size: 12px;\n  font-style: italic;\n  margin: 0;\n}\n", ""]);

